module.exports = __webpack_public_path__ + "img/tips-mail.dd974739.svg";